import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// GitHub Pages serves public/404.html for deep links. That page returns the
// browser here, then we restore the original clean URL before React renders.
const redirectedPath = new URLSearchParams(window.location.search).get('__redirect');
if (redirectedPath && redirectedPath.startsWith('/') && !redirectedPath.startsWith('//')) {
  window.history.replaceState(null, '', redirectedPath);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
